// extracted by mini-css-extract-plugin
export default {"dialog":"RecordingDialog_dialog__cIQyg","container":"RecordingDialog_container__J+-ZU","content":"RecordingDialog_content__bq5FB","isMobile":"RecordingDialog_isMobile__bQAxC"};